<template>
  <div class="userPage">
    <div class="userPage__picture">
      <div class="box box01">
        <div class="title">
          {{ okNum.type }}
          <img src="./img/ok-icon.png" />
        </div>
        <div class="content">
          <div class="content__left" @click="findMonitorSiteRisk(0,'设备新装')">
            <div class="num">
              <em class="theNumStyle">{{ okNum.newDeceive }}</em>
              <span>台</span>
            </div>
            <div class="bom">设备新装</div>
          </div>
          <div class="content__left" @click="findMonitorSiteRisk(1,'运行正常')">
            <div class="num">
              <em class="theNumStyle" style="color: #008b61">{{
                okNum.okDeceive
              }}</em
              ><span>台</span>
            </div>
            <div class="bom">运行正常</div>
          </div>
        </div>
      </div>
      <div class="box box02">
        <div class="title">
          {{ secondNum.riskLevelType }}
          <div class="icon">!</div>
        </div>
        <div class="content">
          <div
            class="content__left"
            v-for="(item, index) in secondNum.alertLevelRiskCounts"
            :key="index"
            @click="findMonitorSiteRisk(item.alertLevel,item.alertLevelName)"
          >
            <div class="num">
              <em class="theNumStyle">{{ item.count }}</em
              ><span>个</span>
            </div>
            <div class="bom">{{ item.alertLevelName }}</div>
          </div>
        </div>
      </div>
      <div class="box box03">
        <div class="title">风险监测 <img src="./img/warn-icon.png" /></div>
        <div class="content">
          <el-carousel
            :interval="5000"
            arrow="always"
            :autoplay="false"
            indicator-position="none"
          >
            <el-carousel-item
              v-for="(item, index) in list"
              :key="index + 'key'"
            >
              <div
                class="content__left"
                v-for="(i, index) in item"
                :key="index"
                @click="findMonitorSiteRisk(i.alertLevel,i.alertLevelName)"
              >
                <div class="num">
                  <em class="theNumStyle" style="color: #d61e1e">{{
                    i.count
                  }}</em
                  ><span>个</span>
                </div>
                <div class="bom">{{ i.alertLevelName }}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <box title="风险分布" class="userPage__middle" over-size>
      <template slot="tip">
        <div class="titleTip">
          <span style="font-size: 14px; color: rgba(0, 0, 0, 0.85)"
            >（<em style="color: rgba(214, 30, 30, 1)">红色</em
            >代表重大风险、<em style="color: rgba(209, 115, 0, 1)">橙色</em
            >代表较大风险、<em style="color: rgba(209, 181, 0, 1)">黄色</em
            >代表一般风险、<em style="color: rgba(11, 71, 165, 1)">蓝色</em
            >代表早期风险、<em style="color: rgba(125, 135, 159, 1)">灰色</em
            >代表误报、<em style="color: rgba(0, 139, 97, 1)">
            绿色</em
            >代表无风险）</span
          >
          <div class="btn">
            <span :class="{ active: isActive }" @click="showNowData()"
              >当前</span
            >
            <span :class="{ active: !isActive }" @click="showHistoryData()"
              >历史</span
            >
          </div>
        </div>
      </template>
      <div class="content">
        <div class="content__left" id="map"></div>
        <div class="content__right">
          <template v-if="showTable">
            <el-table class="listTable" :data="tableList" style="width: 100%">
              <el-table-column
                prop="mostSeriousRiskLevel"
                label="风险等级"
                width="140"
                align="center"
                v-if="!showUnit"
              >
                <template slot-scope="scope">
                  <div :style="getColor(scope.row)[0]">
                    {{ getColor(scope.row)[1] }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="showUnit"
                prop="deptName"
                label="单位"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="monitorName"
                label="监测点名称"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="alertLevelName"
                label="隐患名称"
                width="170"
                align="center"
                v-if="!showUnit"
              >
              </el-table-column>
              <el-table-column
                prop="expireDay"
                label="逾期时间(h)"
                width="100"
                align="center"
                v-if="!isActive && !showUnit"
              >
                <template slot-scope="scope">{{
                  (scope.row.expireDay || 0) + "天"
                }}</template>
              </el-table-column>
              <el-table-column
                prop="timeout"
                label="操作"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="jumpStation(scope.row)"
                    type="text"
                    size="small"
                  >
                    查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-if="!showTable">
            <div class="iconTip">
              <img src="./img/jiantou.png" /><span style="margin-left: 12px"
                >请先在地图上选择单位</span
              >
            </div>
          </template>
        </div>
      </div>
    </box>

    <div class="userPage__bottom">
      <box title="风险统计" over-size>
        <div class="content">
          <div class="chart" ref="chart"></div>
          <div class="total">
            <div class="up">
              <p>风险总量</p>
              <div style="color: #c8cfe0">
                <em class="theNumStyle">{{ warnTotal }}</em
                ><span style="font-size: 20px">个</span>
              </div>
            </div>
            <div class="down">
              <p>近一个月新增</p>
              <div style="color: #d61e1e">
                <em class="theNumStyle">{{ lastMonth }}</em>
                <span style="font-size: 20px">个</span>
              </div>
            </div>
          </div>
        </div>
      </box>
      <box title="能耗统计" over-size>
        <div class="content">
          <div class="content__btn">
            <span :class="{ active02: !isActive02 }" @click="getMonthChart"
              >当月</span
            ><span :class="{ active02: isActive02 }" @click="getDailyChart"
              >当日</span
            >
          </div>
          <div class="chart" ref="chart2"></div>
          <div class="total" v-if="!isActive02">
            <div class="up">
              <p>本月总能耗</p>
              <div style="color: #c8cfe0">
                <em class="theNumStyle">{{ monthtotal  }}</em
                ><span style="font-size: 20px">{{ unit }}</span>
              </div>
            </div>
            <div class="down">
              <p>上月总能耗</p>
              <div style="color: #00b57f">
                <em class="theNumStyle">{{ lastmonthdata }}</em
                ><span style="font-size: 20px">{{ unit2 }}</span>
              </div>
            </div>
          </div>
          <div class="total" v-if="isActive02">
            <div class="up">
              <p>本日总能耗</p>
              <div style="color: #c8cfe0">
                <em class="theNumStyle">{{ daydata }}</em
                ><span style="font-size: 20px">{{ unit }}</span>
              </div>
            </div>
            <div class="down">
              <p>昨日总能耗</p>
              <div style="color: #00b57f">
                <em class="theNumStyle">{{ lastdaydata }}</em
                ><span style="font-size: 20px">{{ unit2 }}</span>
              </div>
            </div>
          </div>
        </div>
      </box>
    </div>
    <div class="risk-history" :class="openclass" >
      <div style="min-width: 750px;">
        <img class="close-X" src="../../assets/station/close.png" v-show="openclass=='opentc'" alt="" @click="openclose()">
        <div class="risk-history-title">
          {{ alertName }}
        </div>
        <div class="search-blank">
        <span class="time-select">

       <span style="margin-left: 20px;">单位：</span>
       <el-cascader
         style="width: 160px;"
         v-model="deptNameList"

         :show-all-levels="false"
         :options="deptdata"
         size="large"
         :props="{ value: 'deptId', label: 'deptName',checkStrictly: true, emitPath: false }"
       ></el-cascader>
            <span style="margin-left: 20px;">监测点：</span>
          <el-input  style="width: 160px;"  size="large" v-model="siteName" placeholder="监测点名称">
          </el-input>
     <span class="search-btn" @click="getRiskList(1)">查询</span>
     <span class="restart-btn" @click="reset()">重置</span>
              </span>
          <div class="list-table">
            <el-table :data="Risktable"  align="center">
              <el-table-column prop="deptName" align="center"  label= "单位名称"></el-table-column>
              <el-table-column prop="siteName" align="center"  label= "监测点名称"></el-table-column>

              <el-table-column align="center"  label="操作">
                <template slot-scope="scope">
                  <el-button  class="dobtn" type="primary"  @click="todetail(scope.row)">
                    详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="float: right;margin-right: 10px; margin-top: 10px;">
            <el-pagination
              @current-change="pageChange"
              background
              :current-page="page"
              :page-size="pageSize"
              layout="total,prev, pager, next, jumper"
              :total="pageall">
            </el-pagination>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import box from "../component/box";
import echarts from "echarts";
import qs from "qs";

export default {
  name: "userPage",
  components: { box },
  inject: ["reload"],
  data() {
    return {
      okNum: {
        type: "",
        newDeceive: 0,
        okDeceive: 0,
      },
      secondNum: {},
      warnNum: {},
      deptdata: {},
      page: 1,
      pageall: 10,
      pageSize: 10,
      time: null,
      showList: false,
      month: null,
      siteName: null,
      year: null,
      deptNameList: null,
      list: [],
      deptList:[],
      tableList: [],
      chart: null,
      chart2: null,
      monthtotal: null,
      lastmonthdata: null,
      daydata: null,
      lastdaydata: null,
      map: null,
      showUnit: false,
      isActive: true,
      isActive02: false,
      warnTotal: 0,
      lastMonth: 0,
      deptId: 0,
      todayDeptEnergy: 0,
      thisMonthDeptEnergy: 0,
      unit: "度",
      unit2: "度",
      showTable: false,
      alertLevel:"",
      alertName:"",
      Risktable:[],
      isopen:false,
      openclass:""
    };
  },
  methods: {
    openclose(){
      if(this.isopen==true){
        this.openclass='closetc'
        this.isopen=false
      }else if(this.isopen==false){
        this.openclass='opentc'
        this.isopen=true
      }
    },
    reset(){
      this.deptNameList=""
      this.siteName=""
      this.getRiskList(1)
    },
    todetail(data){

      this.$router.push({
        name: "stationListPage",
        params: {
          val: [
            data.siteName,
            data.branchId,
            data.id,
            "/stationDetail",
          ],
        },
      });
      Bus.$emit("changeheader", "2");    },
    queryTree() {
      let param = {};
      param.method = "get";
      param.url = "/dept/getDeptTree";
      param.params = {};
      Axios.ajax(param).then((res) => {
        if (res.data) {

          this.deptdata=res.data

        }
      });
    },

    // 当前页数
    pageChange(val) {
      this.page = val;
      this.getRiskList(val);
    },
    getRiskList(page){

      let param = {};
      param.method = "post";
      param.url = "/portal/realtimeRiskMonitorSitePage";
      param.data = {
        pageNum:page,
        showNum:this.pageSize,
        siteName:this.siteName,
        deptId:this.deptNameList,
        alertLevel:this.alertLevel,
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {

          this.Risktable=res.data.dataList
          this.pageall=res.data.totalNum

        }
      });
    },
    jumpStation(item) {
      this.$router.push({
        name: "stationListPage",
        params: {
          val: [
            item.monitorName + "详情",
            item.branchId,
            item.monitorId,
            "/dataDetail",
          ],
        },
      });
      Bus.$emit("changeheader", "2");
    },

    findMonitorSiteRisk(row,levname) {

      this.openclose()
      this.alertLevel=row
      this.alertName=levname
      this.getRiskList();
      // this.isActive = true;
      // this.showTable = true;
      // this.showUnit = true;
      // Axios.ajax({
      //   method: "post",
      //   url: "/portal/alertLevelRealtimeRisks",
      //   data: {
      //     alertLevel: row,
      //   },
      // }).then((res) => {
      //   if (res.data) {
      //     this.tableList = res.data;
      //   }
      // });
    },
    showNowData() {
      this.isActive = true;
      this.showUnit = false;
      this.queryRealtimeList(this.deptId);
    },
    showHistoryData() {
      this.isActive = false;
      this.showUnit = false;
      this.queryHistoryList(this.deptId);
    },
    queryList() {
      let param = {
        method: "post",
        url: "/portal/realtimeRiskCount",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        console.log(res)
        const status = res.data.find(
          (item) => item.riskLevelType === "正常状态"
        );
        this.getOkStatus(status);
        this.secondNum = res.data.find(
          (item) => item.riskLevelType === "误报源识别"
        );
        this.warnNum = res.data.find(
          (item) => item.riskLevelType === "隐患监测"
        );

        this.getWarnStatus(6, this.warnNum.alertLevelRiskCounts);
      });
    },
    queryRealtimeList(id) {
      const param = {
        url: "/portal/realtimeRisks",
        method: "post",
        data: {
          deptId: id,
        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].alertLevelName = res.data[i].alertLevelNames.toString();
          }
          this.tableList = res.data;
        }
        // if (res.data) {
        //   this.tableList = res.data.forEach((item) => {
        //     item.alertLevelName = item.alertLevelNames.toString();
        //   });
        // }
      });
    },
    queryHistoryList(id) {
      const param = {
        url: "/portal/historyRisks",
        method: "post",
        data: {
          deptId: id,
        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].alertLevelName = res.data[i].alertLevelNames.toString();
          }
          this.tableList = res.data;
        }
      });
    },
    handleList(data) {
      // const arr = data.reduce((item, cur) => {
      //   if (cur.mostSeriousRiskLevel) {
      //     if (!item[cur.monitorName]) {
      //       item[cur.monitorName] = cur;
      //     } else if (
      //       item[cur.monitorName].mostSeriousRiskLevel >
      //       item[cur.monitorName].mostSeriousRiskLevel
      //     ) {
      //       item[cur.monitorName] = cur;
      //     }
      //     return item;
      //   }
      // }, []);
      // let res = Object.values(data).map((item) => {
      //   item.alertLevelName = item.alertLevelNames.toString();
      // });
      // return data.map((item) => {
      //   item.alertLevelNames.toString();
      // });
    },
    rank(count) {
      return function (a, b) {
        const value1 = a[count];
        const value2 = b[count];
        return value2 - value1;
      };
    },
    getWarnStatus(num, arr) {
      // 一维数组转换为二维数组
      const iconsArr = []; // 声明数组
      arr.sort(this.rank("count")).forEach((item, index) => {
        if (item.alertLevelName) {
          const page = Math.floor(index / num); // 计算该元素为第几个素组内
          if (!iconsArr[page]) {
            // 判断是否存在
            iconsArr[page] = [];
          }
          iconsArr[page].push(item);
        }
      });

      this.list = iconsArr;
    },
    getOkStatus(row) {
      this.okNum.type = row.riskLevelType;
      this.okNum.newDeceive = row.alertLevelRiskCounts.find(
        (item) => item.alertLevelName === "设备新装"
      ).count;
      this.okNum.okDeceive = row.alertLevelRiskCounts.find(
        (item) => item.alertLevelName === "运行正常"
      ).count;
    },
    initChart() {
      this.$nextTick(() => {
        this.chart = echarts.init(this.$refs.chart);
        this.chart2 = echarts.init(this.$refs.chart2);
      });
    },
    renderChart(data) {
      if (!this.chart) return;
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        color: ["rgba(214, 30, 30, 1)", "rgba(200, 207, 224, 1)"], //legend的图例样式
        legend: {
          data: [
            {
              name: "已整改",
              icon: "circle",
              itemStyle: {
                color: "rgba(214, 30, 30, 1)",
              },
            },
            {
              name: "未整改",
              icon: "circle",
              itemStyle: {
                color: "rgba(200, 207, 224, 1)",
              },
            },
          ],
          textStyle: {
            //文字样式
            color: "#b4c9d1",
            fontSize: "12",
          },
          top: "4%",
          right: "3%",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            //x轴坐标点
            axisTick: {
              show: true,
              alignWithLabel: true,
              lineStyle: {
                color: "#252B3C",
              },
            },
            //x轴坐标线样式
            axisLine: {
              show: true,
              lineStyle: {
                color: "#252B3C",
              },
            },
            axisLabel: {
              fonSize: "12px",
              color: "#252B3C",
              fontWeight: 400,
            },
            //x轴线
            splitLine: {
              show: false,
              lineStyle: {
                type: [5, 10],
                dashOffset: 10,
                color: "#1282C8",
              },
            },
            boundaryGap: true,
            data: data.map((item) => item.dateTime),
          },
        ],
        yAxis: [
          {
            type: "value",

            axisTick: {
              show: false,
              lineStyle: {
                color: "#1282C8",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#1282C8",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(37, 43, 60, 0.15)",
              },
            },
            axisLabel: {
              fonSize: "12px",
              color: "#252B3C",
              fontWeight: 400,
            },
          },
        ],
        series: [
          {
            name: "已整改",
            type: "line",
            smooth: 0.6,
            min: 0,
            symbol: "circle",
            symbolSize: 0,
            lineStyle: {
              normal: {
                color: "rgba(245, 17, 44, 0.35)",
                // 颜色渐变函数 前四个参数分别表示四个位置依次为
                // 右下左上
                // color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                //   {
                //     offset: 0,
                //     color: "#b073f3",
                //   },
                //   {
                //     offset: 0.3,
                //     color: "#ca9bea",
                //   },
                //   {
                //     offset: 0.6,
                //     color: "#d1b0d4",
                //   },
                //   {
                //     offset: 1,
                //     color: "#fae5d9",
                //   },
                // ]), //线条渐变色
                width: 1,
                shadowColor: "rgba(70, 55, 88, 0.35)",
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: 10,
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255, 52, 52, 0)", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "rgba(245, 17, 44, 0.35)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "transparent", //0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            data: data.map((item) => item.unHandledCount),
          },
          {
            name: "未整改",
            type: "line",
            smooth: 0.6,
            min: 0,
            symbol: "circle",
            symbolSize: 0,
            lineStyle: {
              normal: {
                color: "rgba(117, 143, 182, 0.35)",
                width: 1,
                shadowColor: "rgba(70, 55, 88, 0.35)",
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: 10,
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(117, 143, 182, 0.35)", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "rgba(117, 143, 182, 0)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "transparent", //0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            data: data.map((item) => item.unHandledCount),
          },
        ],
      };
      this.chart.setOption(option);
    },
    renderChart2(data, arr, str) {

      if (!this.chart2) return;
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        color: ["rgba(0, 181, 127, 1)", "rgba(200, 207, 224, 1)"],
        legend: {
          data: [
            {
              name: arr[0],
              icon: "circle",
              itemStyle: {
                color: "rgba(0, 181, 127, 1)",
              },
            },
            {
              name: arr[1],
              icon: "circle",
              itemStyle: {
                color: "rgb(13,219,207)",
              },
            },
          ],
          textStyle: {
            //文字样式
            color: "#b4c9d1",
            fontSize: "12",
          },
          top: "4%",
          right: "3%",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            //x轴坐标点
            axisTick: {
              show: true,
              alignWithLabel: true,
              lineStyle: {
                color: "#252B3C",
              },
            },
            //x轴坐标线样式
            axisLine: {
              show: true,
              lineStyle: {
                color: "#252B3C",
              },
            },
            axisLabel: {
              fonSize: "12px",
              color: "#252B3C",
              fontWeight: 400,
            },
            //x轴线
            splitLine: {
              show: false,
              lineStyle: {
                type: [5, 10],
                dashOffset: 10,
                color: "#1282C8",
              },
            },
            boundaryGap: true,
            data: data.map((item) => {
              if (str == "Month") {
                return item.dataTime.slice(5, 10);
              } else {
                return item.dataTime;
              }
            }),
          },
        ],
        yAxis: [
          {
            type: "value",

            axisTick: {
              show: false,
              lineStyle: {
                color: "#1282C8",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#1282C8",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(37, 43, 60, 0.15)",
              },
            },
            axisLabel: {
              fonSize: "12px",
              color: "#252B3C",
              fontWeight: 400,
            },
          },
        ],
        series: [
          {
            name: arr[0],
            type: "line",
            smooth: 0.6,
            min: 0,
            symbol: "circle",
            symbolSize: 0,
            lineStyle: {
              normal: {
                color: "rgba(0, 181, 127, 0.35)",
                // 颜色渐变函数 前四个参数分别表示四个位置依次为
                // 右下左上
                // color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                //   {
                //     offset: 0,
                //     color: "#b073f3",
                //   },
                //   {
                //     offset: 0.3,
                //     color: "#ca9bea",
                //   },
                //   {
                //     offset: 0.6,
                //     color: "#d1b0d4",
                //   },
                //   {
                //     offset: 1,
                //     color: "#fae5d9",
                //   },
                // ]), //线条渐变色
                width: 1,
                shadowColor: "rgba(0, 181, 127, 0.35)",
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: 10,
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(117, 143, 182, 0)", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "rgba(0, 181, 127, 0.35)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "transparent", //0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            data: data.map((item) => item.energy),
          },
          {
            name: arr[1],
            type: "line",
            smooth: 0.6,
            min: 0,
            symbol: "circle",
            symbolSize: 0,
            lineStyle: {
              normal: {
                color: "rgba(117, 143, 182, 0.35)",
                // 颜色渐变函数 前四个参数分别表示四个位置依次为
                // 右下左上
                // color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                //   {
                //     offset: 0,
                //     color: "#b073f3",
                //   },
                //   {
                //     offset: 0.3,
                //     color: "#ca9bea",
                //   },
                //   {
                //     offset: 0.6,
                //     color: "#d1b0d4",
                //   },
                //   {
                //     offset: 1,
                //     color: "#fae5d9",
                //   },
                // ]),
                width: 1,
                shadowColor: "rgba(117, 143, 182, 0.35)",
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: 10,
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 181, 127, 0)", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "rgba(117, 143, 182, 0.35)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "transparent", //0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            data: data.map((item) => item.lastPeriodEnergy),
          },
        ],
      };
      this.chart2.setOption(option);
    },
    initMap() {
      const map = (this.map = new AMap.Map("map", {
        center: [120.21937542, 30.25924446],
        zoom: 14,
        pitch: 30, // 地图俯仰角度，有效范围 0 度- 83 度
        resizeEnable: true,
        expandZoomRange: true,
        zooms: [3, 20],
        showBuildingBlock: true,
      }));
      this.stationLayer = new AMap.OverlayGroup();
      map.add(this.stationLayer);
      AMapUI.loadUI(["control/BasicControl"], (BasicControl) => {
        //缩放按钮
        var zoomCtrl1 = new BasicControl.Zoom({
          theme: "dark",
        });
        map.addControl(zoomCtrl1);
      });
    },
    getColor(row) {
      switch (row.riskLevel || row.mostSeriousRiskLevel) {
        case 5:
          return ["color:#D61E1E", "重大风险"];
        case 4:
          return ["color:#EA8100", "较大风险"];
        case 3:
          return ["color:#CBB000", "一般风险"];
        case 2:
          return ["color:#0B47A5", "早期风险"];
        case 1:
          return ["color:#008B61", "正常"];
        case 6:
          return ["color: #7D879F", "误报源"];
        default:
          return ["color: #7D879F", "误报源"];
      }
    },
    renderStation(stations) {

      let that = this;
      that.map.clearInfoWindow();
      if (that.stationLayer) {
        that.stationLayer.clearOverlays();
      }
      const markersss = [];
      const station = stations.map((station) => {
          if(station.lng !="undefined" &&  station.lat !="undefined"){
            const marker = new AMap.Marker({
              label: {
                content: station.deptName,
                direction: "top", //决定提示内容在icon的方位
              },
              icon: that.getMapIcon(station.mostSeriousRiskLevel),
              position: new AMap.LngLat(station.lng, station.lat),
              zIndex: 1000,
              extData: station,
            });
            marker.on("click", (e) => {
              that.showUnit = false;
              that.showTable = true;
              that.deptId = station.deptId;
              if (that.isActive) {
                that.queryRealtimeList(station.deptId);
              } else {
                that.queryHistoryList(station.deptId);
              }
            });
            markersss.push(marker);
            return marker;
          }

      });
      var sts = [
        {
          url: require("./img/markIcon.png"),
          size: new AMap.Size(148, 127),
          offset: new AMap.Pixel(-60, -50),
          textColor: "#FFFFFF",
          textSize: 30,
        },
        {
          url: require("./img/markIcon.png"),
          size: new AMap.Size(148, 127),
          offset: new AMap.Pixel(-60, -50),
          textColor: "#FFFFFF",
          textSize: 34,
        },
        {
          url: require("./img/markIcon.png"),
          size: new AMap.Size(148, 127),
          offset: new AMap.Pixel(-60, -50),
          textColor: "#FFFFFF",
          textSize: 40,
        },
      ];
      that.map.plugin(["AMap.MarkerClusterer"], function () {
        //实现聚合点功能
        that.cluster = new AMap.MarkerClusterer(that.map, markersss, {
          styles: sts,
          gridSize: 80,
        });
      });

      that.stationLayer.addOverlays(station);
    },
    getMapIcon(num) {
      switch (num) {
        case 6:
          return require("./img/mapIcon06.png");
        case 5:
          return require("./img/mapIcon05.png");
        case 4:
          return require("./img/mapIcon04.png");
        case 3:
          return require("./img/mapIcon03.png");
        case 2:
          return require("./img/mapIcon02.png");
        case 1:
          return require("./img/mapIcon01.png");
        default:
          return require("./img/mapIcon02.png");
      }
    },
    initStation() {
      const params = {
        url: "/portal/regionalPosition",
        method: "post",
        params: {},
      };
      Axios.ajax(params).then((res) => {
        const station = res.data.filter((item) => {
          return item.lng && item.lat;
        });

        this.renderStation(station);
      });
    },
    initChartData() {
      const param = {
        method: "post",
        url: "/portal/riskTrend",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        this.warnTotal = res.data.reduce((prev, cur, index, arr) => {
          return prev + cur.count;
        }, 0);
        this.lastMonth = res.data[res.data.length - 1].count;
        this.renderChart(res.data);
      });
    },
    initNextCharTotalData() {
      const param = {
        method: "post",
        url: "/portal/energyStatis",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        if (res.data.thisMonthDeptEnergy > 10000) {
          this.thisMonthDeptEnergy = (
            res.data.thisMonthDeptEnergy / 10000
          ).toFixed(2);
          this.unit = "万度";
        } else {
          this.unit = "度";
          this.thisMonthDeptEnergy = res.data.thisMonthDeptEnergy;
        }
        if (res.data.todayDeptEnergy > 10000) {
          this.todayDeptEnergy = (res.data.todayDeptEnergy / 10000).toFixed(2);
          this.unit2 = "万度";
        } else {
          this.unit2 = "度";
          this.todayDeptEnergy = res.data.todayDeptEnergy;
        }
      });
    },
    getDailyChart() {
      this.isActive02 = true;
      this.initDayData();
    },
    getMonthChart() {
      this.isActive02 = false;
      this.initMonthData();
    },
    initDayData() {
      const param = {
        url: "/portal/deptHourEnergyTrendTotal",
        method: "post",
        data: {
          localDate: this.time,
        },
      };
      Axios.ajax(param).then((res) => {
        const data = res.data.energyTrends;
        this.daydata=res.data.energyTotal> 10000?(res.data.energyTotal/10000).toFixed(2) + '万' : res.data.energyTotal
        this.lastdaydata=res.data.lastPeriodEnergyTotal > 10000?(res.data.lastPeriodEnergyTotal/10000).toFixed(2) + '万' : res.data.lastPeriodEnergyTotal
        this.renderChart2(data, ["今日", "昨日"], "Day");
      });
    },
    initMonthData() {
      const param = {
        url: "/portal/deptDayEnergyTrendTotal",
        method: "post",
        data: {
          yearMonth: this.month,
        },
      };
      Axios.ajax(param).then((res) => {

        const data = res.data.energyTrends;
        this.monthtotal=res.data.energyTotal > 10000?(res.data.energyTotal/10000).toFixed(2) + '万' : res.data.energyTotal
        this.lastmonthdata=res.data.lastPeriodEnergyTotal > 10000?(res.data.lastPeriodEnergyTotal/10000).toFixed(2) + '万' : res.data.lastPeriodEnergyTotal
        this.renderChart2(data, ["本月", "上月"], "Month");
      });
    },

    formatDateTime(timeStamp) {
      var date = new Date();

      date.setTime(timeStamp);

      var y = date.getFullYear();

      var m = date.getMonth() + 1;

      m = m < 10 ? "0" + m : m;

      var d = date.getDate();

      d = d < 10 ? "0" + d : d;

      var h = date.getHours();

      h = h < 10 ? "0" + h : h;

      var minute = date.getMinutes();

      var second = date.getSeconds();

      minute = minute < 10 ? "0" + minute : minute;

      second = second < 10 ? "0" + second : second;

      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date

      var yesnow = new Date();
      yesnow.setTime(yesnow.getTime() - 30 * 24 * 60 * 60 * 1000);
      var yesyear = yesnow.getFullYear(); //得到年份
      var yesmonth = yesnow.getMonth(); //得到月份
      var yesdate = yesnow.getDate(); //得到日期

      var yeshour = yesnow.getHours(); //得到小时
      var yesminu = yesnow.getMinutes(); //得到分钟
      var yessec = yesnow.getSeconds(); //得到秒
      var yesMS = yesnow.getMilliseconds(); //获取毫秒
      yesmonth = yesmonth + 1;
      if (yesmonth < 10) yesmonth = "0" + yesmonth;
      if (yesdate < 10) yesdate = "0" + yesdate;
      if (yeshour < 10) yeshour = "0" + yeshour;
      if (yesminu < 10) yesminu = "0" + yesminu;
      if (yessec < 10) yessec = "0" + yessec;
      if (yesMS < 100) yesMS = "0" + yesMS;
      var yestime = "";
      yestime =
        yesyear +
        "-" +
        yesmonth +
        "-" +
        yesdate

      this.year = year;
      this.month = year + "-" + month;
      this.time = time;
    },
  },

  created() {
    this.initNextCharTotalData();
    this.queryList();
  },
  mounted() {

    this.getnowtime();
    this.queryTree();
    this.initChart();
    this.initMap();
    this.initStation();
    this.initChartData();
    this.initMonthData();
    // this.initWebSocket();
  },
  watch: {},
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.userPage {
  height: 100%;
  overflow: auto;
  background-color: #e9ecef;
  padding: 24px;
  &__picture {
    height: 140px;

    .box {
      padding: 16px 30px;
      color: #252b3c;
      display: inline-block;
      vertical-align: top;
      .title {
        height: 30px;
        font-weight: 500;
        font-size: 20px;
        position: relative;
        img {
          margin-left: 10px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        .icon {
          margin-left: 113px;
          position: absolute;
          top: 42%;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
          border-radius: 50%;
          background: #3d82ea;
        }
      }
      .content {
        height: 80px;
        display: flex;
        justify-content: space-around;
        align-items: end;
        .content__left {
          text-align: center;
          cursor: pointer;
          .num {
            width: 140px;
            font-size: 40px;
            font-weight: bold;
            span {
              margin-left: 10px;
              font-size: 16px;
              font-weight: 500;
            }
          }
          .bom {
            margin-top: 8px;
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
    }
    .box01 {
      width: 355px;
      background-image: url("./img/ok.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .box02 {
      width: 448px;
      background-image: url("./img/err.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 0 20px;
    }
    .box03 {
      width: calc(100% - 850px);
      background-image: url("./img/warn-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }

  &__middle {
    margin-top: 20px;
    .content {
      padding: 35px 50px;

      &__left {
        width: 1029px;
        height: 492px;
        display: inline-block;
        vertical-align: top;
        background: #dddddd;
      }
      &__right {
        display: inline-block;
        vertical-align: top;
        width: calc(100% - 1080px);
        margin-left: 40px;
        height: 493px;
        overflow: auto;
      }
    }
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 20px;
    .content {
      padding: 21px 0px 20px 50px;
      width: 48.23vw;
      display: flex;
      position: relative;
      &__btn {
        cursor: pointer;
        z-index: 2000;
        position: absolute;
        left: 10%;
        top: 12%;
        font-size: 14px;
        font-weight: 400;
        color: #252b3c;
        span {
          margin: 0 20px;
          padding-bottom: 8px;
        }
        .active02 {
          border-bottom: 3px solid #00b57f;
        }
      }
      .chart {
        width: 34.58vw;
        height: 253px;
      }
      .total {
        margin-left: 42px;
        margin-top: 21px;
        .up {
          margin-bottom: 30px;
        }
        p {
          font-weight: 500;
          color: #252b3c;
          font-size: 16px;
        }
        div {
          font-weight: bold;
          font-size: 32px;
          line-height: 45px;
        }
      }
    }
  }
}
.opentc{

  animation: open 1s;
  animation-fill-mode : forwards;
}
.closetc{
  animation: close 1s;
  animation-fill-mode : forwards;
}
@keyframes open
{
  from {  width: 0px;}
  to {width: 759px;}
}
@keyframes close
{
  from {  width: 759px;}
  to {width: 0px;}
}
.risk-history{
  width: 0;
  height: 750px;
  background: #FFFFFF;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  position: absolute;
  top: 100px;
  right: 21px;
  z-index:1000;
  overflow: hidden;
  .risk-history-title{
    text-align: center;
    color: #252B3C;
    font-size: 16px;
    height: 64px;
    line-height: 64px;
  }
  .close-X{
    margin:10px;
    float:right;
    cursor: pointer;
  }
  .search-blank{
    padding:11px 36px 0 36px;
  }
  .search-btn{
    width: 80px;
    height: 40px;
    background: #2A62FF;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    display:inline-block;
    margin: 0 12px;
    cursor: pointer;
  }
  .restart-btn{
    width: 80px;
    height: 40px;
    background: #fff;
    border-radius: 4px;
    color: #2A62FF;
    text-align: center;
    line-height: 40px;
    display:inline-block;
    border: 1px solid #2A62FF;
    cursor: pointer;
  }
}
.list-table{
  margin-top: 14px;
  height: 565px;
  overflow: auto;
}
//风险分布标题
.titleTip {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  .btn {
    margin-right: 14px;
    font-size: 14px;
    font-weight: normal;
    color: #252b3c;
    line-height: 14px;
    cursor: pointer;
    span {
      padding: 12px;
    }
    .active {
      border-bottom: 2px solid rgba(42, 98, 255, 1);
      color: rgba(42, 98, 255, 1);
    }
  }
}

.theNumStyle {
  font-size: 40px;
  font-family: D-DIN;
}
</style>

<style lang="less" rel="stylesheet/less">
//高德地图样式修改
.amap-logo {
  display: none !important; //去掉高德地图logo
}
.amap-copyright {
  opacity: 0; //去掉高德的版本号
}

.amap-marker-label {
  height: 25px;
  //background-image: url("./img/tipIcon.png");
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
  padding: 0 8px;
  border: none;
  border-radius: 4px;
  background-color: #252b3c;
  top: -30px !important;
}
.amap-marker-label:before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  position: absolute;
  top: 25px;
  left: 44%;
  border-top: 6px solid #252b3c;
}

//el-table的样式
.listTable {
  font-size: 14px !important;
  th {
    background-color: rgba(43, 88, 215, 0.04) !important;
  }
  tr {
    height: 53px;
  }
}
.iconTip {
  height: 100%;
  width: 100%;
  background: rgba(236, 240, 246, 0.6);
  color: #7d879f;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-carousel {
  height: 100%;
  width: 100%;
}
.el-carousel__container {
  height: 100%;
}

.el-carousel__item {
  display: flex;
  justify-content: space-around;
  align-items: end;
}

.el-carousel__arrow {
  background: rgba(0, 0, 0, 0, 0);
  top: 65%;
  font-size: 16px;
  color: rgba(37, 43, 60, 0.5);
}
.el-carousel__arrow--right {
  right: 0;
}
.el-carousel__arrow--left {
  left: 0;
}
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
